import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/forecast.actions';
import * as actionsLocal from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import Table from './Table';
import FilterMenu from './FilterMenu';
import LaunchByHand from './LaunchByHand';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import { FilterIcon, AddIcon } from '../../../../images/icons/WrapSvg';
import Snackbar from '../../../labels/Snackbar';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleFilter, secondary = false) {
    const color = secondary ? 'secondary' : 'primary';
    return <FilterIcon key={'filter-menu-toolbar'} color={color} onClick={handleFilter} />;
}

class Products extends React.Component {
    state = {
        hide: false,
        open: undefined,
        error: undefined,
        filtro: this.props.window_filter.forecast,
        forecasts: [],
    };

    constructor(props) {
        super(props);
        props.all();
        props.allForecast(props.window_filter.forecast);
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter, this.state.filtro !== undefined)];
        this.props.setTools(tools);
    }

    static getDerivedStateFromProps(props, state) {
        const { forecasts, window_filter } = props;
        if (forecasts !== state.forecasts || window_filter.forecast !== state.filtro) {
            const filtro = window_filter.forecast;
            state.filtro = filtro;
            state.forecasts = forecasts;
            state.data = forecasts
                ? forecasts.sort((a, b) => (a.ruta < b.ruta ? -1 : a.id > b.id ? -1 : 1))
                : [];
            return state;
        }
        return null;
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (filtro) => {
        const tools = [toolbar(this.handleFilter, filtro !== undefined)];
        this.props.setTools(tools);
        this.props.allForecast(filtro);
        this.props.setFilter('forecast', filtro);
        this.setState({ open: undefined, filtro: filtro });
    };

    handleClick = () => {
        this.setState({ dialog: true });
    };

    handleCloseDialog = (refresh) => {
        this.setState({ dialog: false });
    };

    handleError = (error) => {
        this.setState({ error: error, dialog: false });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    render() {
        const { info, forecasts_has_errored, forecasts_is_loading } = this.props;
        const { filtro, open, dialog, error, data } = this.state;
        console.log(data);
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '66')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (forecasts_has_errored && forecasts_has_errored.hasErrored) {
            return (
                <Error open type={forecasts_has_errored.hasErrored}  message={forecasts_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    {forecasts_is_loading && <Loading open opacity />}
                    <div className={'flex_80 center'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll height100 padding_bottom_64 bg_ice_blue showbar'
                            }
                        >
                            <Table {...this.props} data={data} filtro={filtro} />
                        </div>
                        <Fab
                            color="primary"
                            aria-label="add"
                            className={'button_float'}
                            onClick={this.handleClick}
                        >
                            <AddIcon />
                        </Fab>
                    </div>
                    {open && (
                        <FilterMenu
                            {...this.props}
                            anchorEl={open}
                            filtro={filtro}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                    {dialog && (
                        <LaunchByHand
                            {...this.props}
                            onClose={this.handleCloseDialog.bind(this)}
                            onError={this.handleError.bind(this)}
                        />
                    )}
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleCloseError.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

Products.propTypes = {
    window_searchs: PropTypes.array.isRequired,
    window_filter: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        window_searchs: state.window_searchs,
        window_filter: state.window_filter,
        forecasts: state.forecasts,
        forecasts_has_errored: state.forecasts_has_errored,
        forecasts_is_loading: state.forecasts_is_loading,
        info: state.info,
        locals: state.locals,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsLocal, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Products));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecasts/Index.js